import React from 'react'
import PaperOption from '../../icons/finger-battle/paper.png';
import RockOption from '../../icons/finger-battle/rock.png';
import ScissorOption from '../../icons/finger-battle/scissor.png';

export default function PlayOption({
  icon,
  handlePlayGame,
  dark
}) {
  return (
    <div
      className={"border-2 hover:border-red-400 hover:bg-red-400 transition-all p-1 rounded " + (dark && " border-red-400 ")}
      title={icon}
      onClick={() => {
        handlePlayGame(icon)
      }}>
      <img
        src={icon === 'paper' ? PaperOption : icon === 'rock' ? RockOption : ScissorOption}
        alt="option"
        width={40}
        height={40}
      />
    </div>
  )
}
